import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("- ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 7 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看合同")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("通过")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "签约列表" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key == 'name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.data.company_name), 1))
              : _createCommentVNode("", true),
            (column.key == 'e_num')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.e_number), 1))
              : _createCommentVNode("", true),
            (column.key == 'contractType')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.contractType.name), 1))
              : _createCommentVNode("", true),
            (column.key == 'time')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("span", null, _toDisplayString(record.expiration_start), 1),
                  _hoisted_4,
                  (!record.expiration_end)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "无期限"))
                    : _createCommentVNode("", true),
                  (record.expiration_end)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.expiration_end), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'commission')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.commission), 1))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (record.status==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "审核通过"))
                    : _createCommentVNode("", true),
                  (record.status==0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "未审核"))
                    : _createCommentVNode("", true),
                  (record.status==2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "审核拒绝"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'image')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 6,
                  src: record.image,
                  style: {"width":"50px"}
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.onStatus(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.getLink(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: "审核"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.pass(0))),
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.pass(1))),
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.reason,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
          rows: 4,
          placeholder: "请输入审核意见"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}